export default __webpack_public_path__ + "static/media/ORIENT Business Center.6028a805.jpg";